import './App.css';

import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import Chat from './pages/Chat';
import { serverURL } from './config';

function App() {
  const params = new URLSearchParams(window.location.search); // 使用 URLSearchParams 解析查询字符串
  const orderId = params.get("orderId");
  const token = params.get("token");
  return (
    <Chat token={token} orderId={orderId} serverUrl={serverURL} />
  );
}

export default App;
